import { BOTANIX, ASSETCHAIN, ASSETCHAIN_TESTNET, ETH_MAINNET } from "config/chains";

import { createClient } from "./utils";

export const chainlinkClient = createClient(ETH_MAINNET, "chainLink");

export const botanixSyntheticsStatsClient = createClient(BOTANIX, "syntheticsStats");

export const botanixSubsquidClient = createClient(BOTANIX, "subsquid");

export const nissohGraphClient = {
  query: async (...args: any[]) => Promise.reject(new Error("Nissoh subgraph is not available on AssetChain")),
};

export function getSyntheticsGraphClient(chainId: number) {
  if (chainId === BOTANIX) {
    return botanixSyntheticsStatsClient;
  }

  if (chainId === ASSETCHAIN || chainId === ASSETCHAIN_TESTNET) {
    return null;
  }

  return null;
}

export function getSubsquidGraphClient(chainId: number) {
  if (chainId === BOTANIX) {
    return botanixSubsquidClient;
  }

  if (chainId === ASSETCHAIN || chainId === ASSETCHAIN_TESTNET) {
    return null;
  }

  return null;
}

export function getGmxGraphClient(chainId: number): any {
  if (chainId === BOTANIX) {
    return null;
  } else if (chainId === ASSETCHAIN || chainId === ASSETCHAIN_TESTNET) {
    return null;
  }

  return null;
}

export function getReferralsGraphClient(chainId): any {
  if (chainId === BOTANIX) {
    return null;
  } else if (chainId === ASSETCHAIN || chainId === ASSETCHAIN_TESTNET) {
    return null;
  }
  return null;
}
